import { z } from 'zod';
import { api } from '@/lib/api';
import { workingContentSchema } from './workingCanvas';
export const WORKING_LIBRARY_QUERY_KEY = ['study-working-library'];
const contextSchema = z.object({
  kind: z.enum(['practice', 'study', 'mock', 'free', 'material']),
  question_id: z.string(),
  session_id: z.string().optional(),
});
export const workingSummarySchema = z.object({
  id: z.string().uuid(),
  version: z.number().int().positive(),
  title: z.string(),
  question: z.string().nullable(),
  locked: z.boolean(),
  context: contextSchema,
  updated_at: z.string().datetime(),
  retention_until: z.string().datetime().nullable(),
  stroke_count: z.number().int().nonnegative(),
  byte_size: z.number().int().nonnegative(),
});
export type WorkingSummary = z.infer<typeof workingSummarySchema>;
const librarySchema = z.object({
  items: z.array(workingSummarySchema),
  next_cursor: z.string().uuid().nullable(),
});
export async function listWorkingCanvases(kind: string, cursor?: string) {
  const query = new URLSearchParams({ ...(kind ? { kind } : {}), ...(cursor ? { cursor } : {}) });
  return librarySchema.parse(
    await api<unknown>(`/study/working-canvases${query.size ? `?${query}` : ''}`),
  );
}
export async function getSavedWorking(id: string) {
  return workingSummarySchema
    .extend({ content: workingContentSchema })
    .parse(await api<unknown>(`/study/working-canvases/${encodeURIComponent(id)}`));
}
